import { List } from "iconoir-react";
import { useTranslation } from "react-i18next";
import {
  ControlledAddressAutofill,
  ControlledInput,
  ControlledTextArea,
  PageHeader,
  ViewSubSection,
} from "shared/components";
import { Flex } from "styled-system/jsx";

export const Profile = () => {
  const { t } = useTranslation("directory", {
    keyPrefix: "ORGANIZATION.PROFILE",
  });
  return (
    <Flex flexDir={"column"} h={"fit-content"} w={"full"} gap={"400"}>
      <PageHeader
        title={t("TAB_TITLE")}
        Icon={List}
        description={t("DESCRIPTION")}
      />
      <ViewSubSection title={t("KEY_INFO.TITLE")}>
        <Flex flexDir={"column"} gap={"200"}>
          <ControlledInput name={"name"} label={t("FORM.LABELS.NAME")} />
          <ControlledInput name={"website"} label={t("FORM.LABELS.WEBSITE")} />
          <Flex gap={"200"}>
            <ControlledInput name={"phone"} label={t("FORM.LABELS.PHONE")} />
            <ControlledInput
              name={"email"}
              label={t("FORM.LABELS.EMAIL")}
              type="email"
            />
          </Flex>
          <ControlledAddressAutofill
            addressInputName={"fullAddress"}
            addressLabel={t("FORM.LABELS.ADDRESS")}
            addressObjInputName={"fullAddressObj"}
            coordsInputName={"fullAddressObj.location.coordinates"}
            lngInputName={"fullAddressObj.location.coordinates.lng"}
            latInputName={"fullAddressObj.location.coordinates.lat"}
          />
          <ControlledTextArea
            name={"description"}
            label={t("FORM.LABELS.DESCRIPTION")}
          />
          <ControlledTextArea
            name={"shortDescription"}
            label={t("FORM.LABELS.SHORT_DESCRIPTION")}
            rows={3}
          />
        </Flex>
      </ViewSubSection>
      <ViewSubSection title={t("SOCIAL_LINKS.TITLE")}>
        <Flex flexDir={"column"} gap={"200"}>
          <ControlledInput
            name={"facebook"}
            label={t("FORM.LABELS.FACEBOOK")}
          />
          <ControlledInput
            name={"instagram"}
            label={t("FORM.LABELS.INSTAGRAM")}
          />
          <ControlledInput name={"x"} label={t("FORM.LABELS.X")} />
          <ControlledInput name={"youtube"} label={t("FORM.LABELS.YOUTUBE")} />
          <ControlledInput
            name={"pinterest"}
            label={t("FORM.LABELS.PINTEREST")}
          />
          <ControlledInput
            name={"googleMyBusiness"}
            label={t("FORM.LABELS.GOOGLE_MY_BUSINESS")}
          />
          <ControlledInput name={"tiktok"} label={t("FORM.LABELS.TIKTOK")} />
        </Flex>
      </ViewSubSection>
    </Flex>
  );
};
